/**
 * PorcionadoApiClient -- bandeja de porcionado pendiente (kiosk).
 * INVENTARIO-PORCIONADO-ALERTAS-V1-001 / PORC-A2 (backend, PR nexo-api #120,
 * bit #3156) / PORC-P1-P2 (panel, bit #3153/#3157).
 *
 * Contrato leido del diff REAL del PR (no adivinado):
 *   GET   /api/v1/businesses/{id}/porcionado-pendiente
 *         -> { items:[{facturaItemId,facturaId,numeroFactura,insumoId,insumoNombre,
 *              descripcionRaw,gramos,unidadFactura,motivo,egresoSyncId,fechaFactura,
 *              creadoAt}], total }
 *   PATCH /api/v1/businesses/{id}/porcionado-pendiente/{facturaItemId}/cerrar
 *         body:{ porcionesRegistradas?, movimientoId?, usuario?, nota? }
 *         -> { facturaItemId, cerrada:bool }
 *
 * El registro REAL del porcionado va por POST movimiento ENTRADA existente
 * (ComprasApiClient.createMovimiento) -- este PATCH SOLO cierra la alerta y
 * deja traza de auditoria (backend NO lo hace automatico).
 *
 * @module infrastructure/api/PorcionadoApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/businesses';

export const PorcionadoApiClient = {
  /**
   * @param {string} businessId
   * @returns {Promise<{ok:boolean, items?:Array, total?:number}>}
   */
  async listPendientes(businessId) {
    if (!businessId) return { ok: false, error: { code: 'BUSINESS_REQUIRED' } };
    const res = await ApiBase.get(`${BASE}/${encodeURIComponent(businessId)}/porcionado-pendiente`);
    if (!res.ok) return res;
    const d = res.data?.data ?? res.data ?? {};
    return { ok: true, items: Array.isArray(d.items) ? d.items : [], total: d.total ?? 0 };
  },

  /**
   * @param {string} businessId
   * @param {string} facturaItemId
   * @param {{ porcionesRegistradas?:number, movimientoId?:string, usuario?:string, nota?:string }} payload
   */
  async cerrarAlerta(businessId, facturaItemId, payload = {}) {
    if (!businessId || !facturaItemId) return { ok: false, error: { code: 'PARAMS_REQUIRED' } };
    const res = await ApiBase.patch(
      `${BASE}/${encodeURIComponent(businessId)}/porcionado-pendiente/${encodeURIComponent(facturaItemId)}/cerrar`,
      payload
    );
    if (!res.ok) return res;
    const d = res.data?.data ?? res.data ?? {};
    return { ok: true, data: { facturaItemId: d.facturaItemId, cerrada: !!d.cerrada } };
  }
};
